var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',{staticClass:"float-right"},[(_vm.$temAcessoView('ADMIN-FILIAIS-01'))?_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.inserirFilial()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Nova filial")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }